export const removeObjectFromArray = <A extends any[], K extends keyof A[number]>(
  array: A,
  objectMatchKey: K,
  objectMatchValue: A[number][K],
) => array.filter((el) => el[objectMatchKey] !== objectMatchValue);
